import { observer } from 'mobx-react-lite';
import { type ComponentProps } from 'react';

import { ACTIVE_HOLIDAY } from '../../config/Environment';
import { Logo } from '../Logo/Logo';
import { ChristmasLogo } from './christmas/ChristmasLogo';
import { FourthOfJulyLogo } from './fourth-of-july/Logo';
import { Holiday } from './getActiveHoliday';
import { HalloweenLogo } from './halloween/HalloweenLogo';
import { NyeLogo } from './nye/NyeLogo';
import { ThanksgivingLogo } from './thanksgiving/ThanksgivingLogo';
import { ValentineLogo } from './valentine/ValentineLogo';

const HOLIDAY_LOGO_MAP = {
	[Holiday.FourthOfJuly]: FourthOfJulyLogo,
	[Holiday.Thanksgiving]: ThanksgivingLogo,
	[Holiday.NewYear]: NyeLogo,
	[Holiday.Valentine]: ValentineLogo,
	[Holiday.Christmas]: ChristmasLogo,
	[Holiday.Halloween]: HalloweenLogo,
} as const satisfies Record<Holiday, typeof Logo>;

export const HolidayLogo = observer(function HolidayLogo(props: ComponentProps<typeof Logo>) {
	const ThemedLogo = ACTIVE_HOLIDAY ? HOLIDAY_LOGO_MAP[ACTIVE_HOLIDAY] : Logo;

	return <ThemedLogo {...props} />;
});
